import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappApiForDevelopersContent from './WhatsappApiForDevelopersContent';

const WhatsappApiForDevelopers = () => (
  <>
    <Helmet>
      <title>WhatsApp API for Developers: REST API &amp; Webhooks | HAWKTRION</title>
      <meta name="description" content="Build WhatsApp integrations with HAWKTRION APIs, templates, media messaging, and webhooks. Explore developer tools for business messaging workflows." />
      <meta name="keywords" content="WhatsApp API for developers, WhatsApp REST API, WhatsApp API webhooks" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api-for-developers/" />
      <meta property="og:title" content="WhatsApp API for Developers: REST API &amp; Webhooks | HAWKTRION" />
      <meta property="og:description" content="Build WhatsApp integrations with HAWKTRION APIs, templates, media messaging, and webhooks. Explore developer tools for business messaging workflows." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api-for-developers/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API for Developers: REST API &amp; Webhooks | HAWKTRION" />
      <meta name="twitter:description" content="Build WhatsApp integrations with HAWKTRION APIs, templates, media messaging, and webhooks. Explore developer tools for business messaging workflows." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp API for Developers and Integrations" hideCta>
      <WhatsappApiForDevelopersContent />
    </SeoLandingPage>
  </>
);

export default WhatsappApiForDevelopers;